var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/return_logo.75dd988a.png","uri@2x": __webpack_public_path__ + "static/media/return_logo.fd65cf6f.png","uri@3x": __webpack_public_path__ + "static/media/return_logo.a6342861.png",
    width: 13,
    height: 9
});